export default __webpack_public_path__ + "static/media/330_dummy2016-reiseblog01-mobile-de.b8090231.png";